import { Link, useLocation } from 'react-router-dom'
import { Home, Layers, BookOpen, Gift, ChevronLeft } from 'lucide-react'

interface LayoutProps {
  children: React.ReactNode
}

const navItems = [
  { path: '/', label: 'Inicio', icon: Home },
  { path: '/cards', label: 'Colección', icon: Layers },
  { path: '/decks', label: 'Mazos', icon: BookOpen },
  { path: '/packs', label: 'Packs', icon: Gift },
]

const pageTitles: Record<string, string> = {
  '/cards': 'Colección',
  '/decks': 'Mazos',
  '/deck': 'Mazo',
  '/packs': 'Packs',
  '/battle': 'Batalla',
  '/evolution': 'Evolución',
  '/spaces': 'Espacios',
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const isHome = location.pathname === '/'
  const currentPageTitle = pageTitles[location.pathname] || pageTitles[location.pathname.split('/')[1]] || ''

  return (
    <div className={`min-h-[100dvh] ${isHome ? 'bg-[#0f1115]' : 'bg-slate-900'} flex flex-col`}>
      <nav className={`${isHome ? 'absolute' : 'sticky'} top-0 left-0 right-0 z-50 bg-transparent hidden md:block`}>
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-center items-center h-16">
            <div className="hidden md:flex items-center gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-5 py-3 text-base font-semibold rounded-lg transition-all duration-200 ${
                    location.pathname === item.path
                      ? 'text-white bg-slate-800'
                      : 'text-white hover:bg-slate-800/70'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {!isHome && currentPageTitle && (
        <div className="md:hidden fixed top-0 left-0 right-0 z-40 bg-slate-900/95 backdrop-blur-sm border-b border-slate-800 h-14 flex items-center px-4">
          <h1 className="text-lg font-bold text-white">{currentPageTitle}</h1>
        </div>
      )}

      <main className="flex-1 pb-20 md:pb-0">
        <div className={isHome ? '' : 'pt-14 md:pt-0'}>
          {children}
        </div>
      </main>

      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-[#1a1e24] border-t border-[#2d3540] z-50">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.path
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors ${
                  isActive ? 'text-amber-500' : 'text-slate-400'
                }`}
              >
                <Icon size={24} />
                <span className="text-[10px] font-medium">{item.label}</span>
              </Link>
            )
          })}
        </div>
      </div>

      <footer className={`hidden md:block ${isHome ? 'absolute bottom-0 left-0 right-0 bg-transparent pb-6' : 'py-6 px-4 border-t border-slate-800'}`}>
        <div className="max-w-6xl mx-auto text-center">
          <p className={`text-sm ${isHome ? 'text-slate-400' : 'text-slate-500'}`}>
            © 2026 TCG-Gen. Herramienta para TCG.
          </p>
        </div>
      </footer>
    </div>
  )
}
